import { Helmet } from "react-helmet-async";

const SeoPage = ({ title, description, keywords, url }) => {
  const siteName = "Bharat Clouds";
  const fullTitle = title ? `${title} | ${siteName}` : siteName;

  return (
    <Helmet>
      <title>{fullTitle}</title>

      {description && <meta name="description" content={description} />}
      {keywords && <meta name="keywords" content={keywords} />}

      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />

      <meta name="twitter:card" content="summary_large_image" />
    </Helmet>
  );
};

export default SeoPage;
